import { render, staticRenderFns } from "./modal-component.vue?vue&type=template&id=7ae185c8&"
import script from "./modal-component.vue?vue&type=script&lang=js&"
export * from "./modal-component.vue?vue&type=script&lang=js&"
import style0 from "./modal-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae185c8')) {
      api.createRecord('7ae185c8', component.options)
    } else {
      api.reload('7ae185c8', component.options)
    }
    module.hot.accept("./modal-component.vue?vue&type=template&id=7ae185c8&", function () {
      api.rerender('7ae185c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/modal-component.vue"
export default component.exports